
// import { defineComponent, reactive, toRefs, provide } from "vue";
import { defineComponent, onMounted, reactive, toRefs, watch } from "vue";
import { Todo } from "./types/Todo";
import { setCache, getCache } from './cache'
import Head from "./components/Head.vue";
import List from "./components/List.vue";
import Footer from "./components/Footer.vue";
export default defineComponent({
    name: "App",
    components: {
        Head,
        List,
        Footer,
    },
    setup() {
        const state = reactive<{ todos: Todo[] }>({
            todos: [
                {
                    id: 1,
                    title: "测试",
                    isChecked: true,
                },
                {
                    id: 2,
                    title: "测试1",
                    isChecked: false,
                },
                {
                    id: 3,
                    title: "测试2",
                    isChecked: true,
                },
            ],
        });

        onMounted(() => {
            if (getCache('todos')) {
                state.todos = getCache('todos');
            }
        })

        const addTodo = (todo: Todo) => {
            state.todos.unshift(todo);
        };
        const deleteTodo = (index: number) => {
            state.todos.splice(index, 1);
        };

        const changeTodoisChecked = (todo: Todo, isChecked: boolean) => {
            todo.isChecked = isChecked;
        };

        const clearIsCheckedTodo = () => {
            state.todos = state.todos.filter((v: Todo) => !v.isChecked);
        }

        watch(() => state.todos, (value: Todo[]) => {
            setCache('todos', value);
        },{deep: true})

        return {
            ...toRefs(state),
            addTodo,
            deleteTodo,
            changeTodoisChecked,
            clearIsCheckedTodo,
        };
    },
});
